import { Translate } from '@chipinside/translate'

import { FormProps, UseFormsProps } from '#/store/hooks/useForms/types'
import { endpoint } from '#/store/services/endpoints'

const userForms = {
  user: {
    password: (): UseFormsProps => ({
      controller: endpoint.user.me.pwd_change_form(),
      save: {
        controller: endpoint.auth.change_password(),
        method: 'post',
      },
      title: Translate({ messageKey: 'change_password' }),
      width: 'xs',
    }),
    reset_password: ({
      params,
    }: FormProps<{ userName: string; userEmail: string }>): UseFormsProps => ({
      level: 'info',
      message: Translate({
        messageKey: 'change_password_confirmation',
        params: {
          userEmail: params?.userEmail as string,
          userName: params?.userName as string,
        },
      }),
      save: {
        // @ts-ignore
        controller: `${import.meta.env.VITE_AUTH_URL}/forgot-password`,
        manipulateParams(values) {
          return {
            ...values,
            email: params?.userEmail,
          }
        },
        method: 'post',
      },
      subtitle: params?.userEmail,
      title: Translate({
        messageKey: 'reset_item',
        params: {
          item: Translate({ lower: true, messageKey: 'password' }),
        },
      }),
    }),
    update: (): UseFormsProps => ({
      controller: endpoint.user.me.form(),
      save: {
        controller: endpoint.user.me.register(),
        method: 'put',
      },
    }),
  },
}

export { userForms }
